import React from 'react';
import {useTranslation} from 'react-i18next';

import {ChatCenteredText, Check} from '../icons';
import {achievementsOf, essentialsOf, percentOf} from './state/learnModel';

/**
 * La columna derecha: el anillo de lo esencial, los logros (una pista completa, no puntos) con el
 * aviso de qué ve el Admin, y la salida humana — el chat de soporte, el mismo de toda la app.
 */
export function LearnRail({model, onOpenHelp}) {
    const {t} = useTranslation();
    const essentials = essentialsOf(model);
    const achievements = achievementsOf(model);

    return (
        <aside className="ld-rail">
            {essentials && <EssentialsCard essentials={essentials}/>}

            <section className="ld-card">
                <h2 className="ld-card__title">{t('learn_dashbo.rail.achievements')}</h2>
                <ul className="ld-medals">
                    {achievements.map((achievement, index) => {
                        const label = t(`learn_dashbo.achievements.${achievement.key}`);
                        return (
                            <li key={achievement.key} className={`ld-medal${achievement.got ? ' -got' : ''}`}>
                                <span className="ld-medal__icon" aria-hidden="true">
                                    {achievement.got ? <Check size={16} weight="bold"/> : index + 1}
                                </span>
                                <span className="ld-medal__label">{label}</span>
                                <span className="visually-hidden">
                                    {t(achievement.got ? 'learn_dashbo.achievements.got' : 'learn_dashbo.achievements.locked')}
                                </span>
                            </li>
                        );
                    })}
                </ul>
                <p className="ld-card__note">{t('learn_dashbo.rail.share_notice')}</p>
            </section>

            <section className="ld-card ld-help">
                <h2 className="ld-card__title">{t('learn_dashbo.rail.help_title')}</h2>
                <p className="ld-card__text">{t('learn_dashbo.rail.help_text')}</p>
                <button type="button" className="ld-help__chat" onClick={onOpenHelp}>
                    <ChatCenteredText size={16} aria-hidden="true"/>
                    {t('learn_dashbo.rail.help_chat')}
                </button>
            </section>
        </aside>
    );
}

function EssentialsCard({essentials}) {
    const {t} = useTranslation();
    const left = essentials.total - essentials.done;
    const percent = percentOf(essentials.done, essentials.total);

    return (
        <section className="ld-card ld-essentials">
            <h2 className="ld-card__title">{t('learn_dashbo.rail.essentials_title')}</h2>
            <div className="ld-ring" role="progressbar" aria-label={t('learn_dashbo.rail.essentials_title')}
                 aria-valuemin={0} aria-valuemax={essentials.total} aria-valuenow={essentials.done}
                 aria-valuetext={t('learn_dashbo.track.progress_text', {done: essentials.done, total: essentials.total})}
                 style={{'--ld-p': percent}}>
                <span className="ld-ring__inner" aria-hidden="true">
                    {essentials.achieved ? <Check size={20} weight="bold"/> : `${essentials.done}/${essentials.total}`}
                </span>
            </div>
            <p className="ld-card__text">
                {essentials.achieved
                    ? t('learn_dashbo.rail.essentials_done')
                    : t('learn_dashbo.rail.essentials_left', {count: left, minutes: essentials.minutesLeft})}
            </p>
        </section>
    );
}
